import React from 'react';
import Footer from '../components/Footer';

const TermsAndConditions: React.FC = () => {
  return (
    <>
      <section className='legal-content'>
  <h1 className='titles large color black'>Terms and Conditions</h1>
  <p className='paragraphs medium color dark-charcoal'><em>Last updated: June 17, 2025.</em></p>

  <p className='paragraphs medium color dark-charcoal'>These Terms and Conditions ("Terms") govern your access to and use of the mobile application and website (together, the "Service") provided by <strong>Appetite App Ltd</strong> (ABN 46290838577) ("we", "us", or "our"). By creating an account or using the Service, you agree to be bound by these Terms.</p>

  <h2 className='titles small color dark-charcoal'>1. Use of the Service</h2>
  <ul className='paragraphs medium color dark-charcoal'>
    <li>The Service allows users to subscribe to and interact with content provided by food creators.</li>
    <li>You must be at least 13 years old (or the minimum age in your jurisdiction) to use the Service.</li>
    <li>Creators are solely responsible for the content they upload. We do not moderate or verify creator content.</li>
    <li>You may not use the Service for any unlawful or prohibited purpose.</li>
  </ul>

  <h2 className='titles small color dark-charcoal'>2. Accounts and Subscriptions</h2>
  <ul className='paragraphs medium color dark-charcoal'>
    <li>Creating an account is required to access paid content or features.</li>
    <li>Subscriptions are tied to individual creators. Each subscription gives you access only to the creator you subscribed to.</li>
    <li>A free trial period of 7 days is available for new subscriptions, after which charges apply unless cancelled.</li>
    <li>Subscriptions renew automatically (monthly, annually, or per creator-defined intervals) unless cancelled.</li>
    <li>Refunds are not issued for monthly plans. Annual plans may be partially refunded on a discretionary, case-by-case basis.</li>
  </ul>

  <h2 className='titles small color dark-charcoal'>3. Payments</h2>
  <ul className='paragraphs medium color dark-charcoal'>
    <li>All payments are processed securely via Stripe. We do not store your payment details.</li>
    <li>Pricing and billing intervals are set by the individual creator and displayed at the time of purchase.</li>
    <li>You may cancel your subscription at any time. Your access will continue until the end of the billing period.</li>
  </ul>

  <h2 className='titles small color dark-charcoal'>4. Creator Content</h2>
  <ul className='paragraphs medium color dark-charcoal'>
    <li>Creators retain ownership of all content they upload, including recipes, photos, and videos.</li>
    <li>By uploading content, creators grant us a license to host and display it via the Service solely for delivering their subscriptions.</li>
    <li>We are not liable for any inaccuracies, omissions, or issues arising from creator content.</li>
  </ul>

  <h2 className='titles small color dark-charcoal'>5. User Content and Conduct</h2>
  <ul className='paragraphs medium color dark-charcoal'>
    <li>You may post comments, replies, and photos in designated areas of the app.</li>
    <li>You must comply with our Community Guidelines, which prohibit offensive, violent, discriminatory, illegal, or otherwise inappropriate content.</li>
    <li>Creators may moderate user content within their own community space and remove inappropriate posts.</li>
    <li>We reserve the right to suspend, restrict, or terminate accounts that violate these Terms or our policies.</li>
  </ul>

  <h2 className='titles small color dark-charcoal'>6. Intellectual Property</h2>
  <p className='paragraphs medium color dark-charcoal'>All rights, title, and interest in the Service (excluding user and creator content) are owned by Appetite App Ltd. You may not copy, modify, distribute, sell, or lease any part of our Service without prior written consent.</p>

  <h2 className='titles small color dark-charcoal'>7. Availability and Disclaimer</h2>
  <ul className='paragraphs medium color dark-charcoal'>
    <li>The Service is provided "as is" and "as available" without warranties of any kind.</li>
    <li>We do not guarantee uninterrupted access, error-free operation, or that the Service will meet your expectations.</li>
    <li>The Service is not intended to provide medical, dietary, or nutritional advice. Please consult a qualified professional for such guidance.</li>
  </ul>

  <h2 className='titles small color dark-charcoal'>8. Termination</h2>
  <ul className='paragraphs medium color dark-charcoal'>
    <li>We may terminate or suspend your access to the Service at any time for violation of these Terms.</li>
    <li>You may stop using the Service at any time by deleting your account or cancelling subscriptions.</li>
  </ul>

  <h2 className='titles small color dark-charcoal'>9. Limitation of Liability</h2>
  <p className='paragraphs medium color dark-charcoal'>To the extent permitted by law, we are not liable for any indirect, incidental, special, consequential or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data or goodwill.</p>

  <h2 className='titles small color dark-charcoal'>10. Governing Law</h2>
  <p className='paragraphs medium color dark-charcoal'>These Terms are governed by the laws of Victoria, Australia. Any disputes arising from these Terms will be resolved under the jurisdiction of Australian courts, unless otherwise required by local laws in your country of residence.</p>

  <h2 className='titles small color dark-charcoal'>11. Dispute Resolution</h2>
  <p className='paragraphs medium color dark-charcoal'>We encourage users to contact us directly to resolve any issues or concerns. If a resolution cannot be reached, the matter may be addressed through mediation or other dispute resolution mechanisms under Australian law.</p>

  <h2 className='titles small color dark-charcoal'>12. Changes to the Terms</h2>
  <p className='paragraphs medium color dark-charcoal'>We may update these Terms from time to time. When we do, we will revise the "Last updated" date. Continued use of the Service constitutes your acceptance of any updates.</p>

  <h2 className='titles small color dark-charcoal'>13. Contact Us</h2>
  <p className='paragraphs medium color dark-charcoal'>If you have questions about these Terms, please contact:</p>
  <p className='paragraphs medium color dark-charcoal'>
    <strong>Appetite App Ltd</strong><br />
    Email: <a href='mailto:support@appetiteapp.com'>support@appetiteapp.com</a><br />
    Postal: 123 Main St, Melbourne, VIC 3000, Australia
  </p>
</section>
      <Footer />
    </>
  );
};

export default TermsAndConditions; 